import { getQuery, postMutation, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { GET_FILE_FOR_CLINIC, GET_FILE_FOR_DOCG, LIST_CLINIC_REQUEST } from "src/components/graphql/GraphQLquery";
import { CLINIC_APPROVAL, CLINIC_REJECTION, UPLOAD_FILE_FOR_CLINIC, UPLOAD_FILE_FOR_DOCG, } from "src/components/graphql/GraphQLmutation";
import { snackbar } from "@mobiscroll/react5";

export async function approveClinicCreationRequest(data) {
  try {
    const response = await postMutation(CLINIC_APPROVAL, data);

    if (typeof response === "undefined" || response?.errors) {
      throw new Error("error", response);
    } else {
      if (
        response.data.approveClinicCreationRequest.statusCode < 300 &&
        response.data.approveClinicCreationRequest.statusCode >= 200
      ) {
        snackbar({
          message: "Doctor/Clinic Approved Successfully.",
          color: "success",
        });
        return true;
      } else {
        throw new Error(response.data.approveClinicCreationRequest.message);
      }
    }
  } catch (e) {
    snackbar({
      message: e.message ? e.message : "Something went wrong",
      color: "danger",
    });
    console.error("Error at approveClinicCreationRequest: ", e);
    return false;
  }
}

export async function rejectClinicCreationRequest(data) {
  try {
    const response = await postMutation(CLINIC_REJECTION, data);

    if (typeof response === "undefined" || response?.errors) {
      throw new Error("error", response);
    } else {
      if (
        response.data.rejectClinicCreationRequest.statusCode < 300 &&
        response.data.rejectClinicCreationRequest.statusCode >= 200
      ) {
        snackbar({
          message: "Doctor/Clinic Rejected Successfully.",
          color: "success",
        });
        return true;
      } else {
        throw new Error(response?.data?.rejectClinicCreationRequest.message);
      }
    }
  } catch (e) {
    if (e.message.length > 200) {
      snackbar({
        message: "Some error occured while Rejecting. Try again",
        color: "danger",
      });
    } else
      snackbar({
        message: e.message,
        color: "danger",
      });

    console.error("Error at rejectClinicCreationRequest: ", e);
    return false;
  }
}

export async function listClinicCreationRequests(displayRecords, filters) {
  try {
    let response = await getQuery(LIST_CLINIC_REQUEST(displayRecords, filters));

    if (typeof response === "undefined" || response?.errors) {
      throw new Error("error", response);
    } else {
      if (response.data.listClinicCreationRequests.data) {
        snackbar({
          message: "Clinic Creation request Fetched Successfully",
          color: "success",
        });
        return response.data.listClinicCreationRequests;
      } else {
        throw new Error(response);
      }
    }
  } catch (e) {
    snackbar({
      message: e?.message || "Error at fetching clinic creation requests.",
      color: "danger",
    });
    console.error("Error at listClinicCreationRequests: ", e);
    return { data: [] };
  }
}

export async function uploadFileForDocg(data) {
  try {
    const response = await postMutation(UPLOAD_FILE_FOR_DOCG, data, true);

    if (
      typeof response === "undefined" ||
      response?.errors ||
      !(
        response?.data?.uploadFileForDocg?.statusCode < 300 &&
        response?.data?.uploadFileForDocg?.statusCode >= 200
      )
    ) {
      throw new Error("error", response?.data?.uploadFileForDocg?.message);
    } else {
      return response?.data?.uploadFileForDocg?.data ?? true;
    }
  } catch (e) {
    snackbar({ message: e.message ?? "Some error occured while uploading file", color: "danger", });
    console.error("Error at uploading file: ", e);
    return false;
  }
}

export async function uploadFileForClinic(fileType, ext) {
  try {
    const response = await postMutation(UPLOAD_FILE_FOR_CLINIC, { fileType, ext }, true);
    const result = response?.data?.uploadGenericTermsFileForClinic;

    if (typeof response === "undefined" || !(result?.statusCode < 300 && result?.statusCode >= 200)) {
      throw new Error("error", result?.message ?? "Failed to upload file");
    } else {
      return result?.data ?? true;
    }
  } catch (e) {
    snackbar({ message: e.message ?? "Some error occured while uploading file", color: "danger", });
    console.error("Error at uploading file: ", e);
    return false;
  }
}

export async function getFileForDocg(fileType) {
  try {
    const response = await getQuery(GET_FILE_FOR_DOCG, { fileType }, true);
    if (
      typeof response === "undefined" ||
      response?.errors ||
      !(
        response?.data?.getFileForDocg?.statusCode < 300 &&
        response?.data?.getFileForDocg?.statusCode >= 200
      )
    ) {
      throw new Error(
        response?.data?.getFileForDocg?.message || "Some Error occured"
      );
    } else {
      snackbar({
        message: "File Fetched Successfully",
        color: "success",
      });
      return response?.data?.getFileForDocg?.data;
    }
  } catch (e) {
    snackbar({
      message: e?.message,
      color: "danger",
    });
    console.error("Error at createRazorpayPlan: ", e);
    return false;
  }
}

export async function getFileForClinic(fileType) {
  try {
    const response = await getQuery(GET_FILE_FOR_CLINIC, { fileType }, true);
    if (
      typeof response === "undefined" ||
      response?.errors ||
      !(
        response?.data?.getGenericTermsFileForClinic?.statusCode < 300 &&
        response?.data?.getGenericTermsFileForClinic?.statusCode >= 200
      )
    ) {
      throw new Error(
        response?.data?.getGenericTermsFileForClinic?.message ||
        "Some Error occured"
      );
    } else {
      snackbar({
        message: "File Fetched Successfully",
        color: "success",
      });
      return response?.data?.getGenericTermsFileForClinic?.data;
    }
  } catch (e) {
    snackbar({
      message: e?.message,
      color: "danger",
    });
    console.error("Error at createRazorpayPlan: ", e);
    return false;
  }
}